module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/140a12db35626907175324712db456a7.gif";